import { render, staticRenderFns } from "./xterm.vue?vue&type=template&id=21695574"
import script from "./xterm.vue?vue&type=script&lang=js"
export * from "./xterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports